module.exports = __webpack_public_path__ + "static/media/yt_logo_rgb_light.07b8560a.png";